export default __webpack_public_path__ + "static/media/beginImage.571af68d.png";